import {
  acceptDeal,
  buyProperty,
  commitMove,
  confirmPrompt,
  declineDeal,
  endTurn,
  mortgageProperty,
  payBail,
  reroll,
  rollDice,
  sellAsset,
  sellProperty,
  skipBuy,
  surrender,
  unmortgageProperty,
  upgradeProperty,
} from './engine'
import type { GameState } from './types'

/**
 * คำสั่งทั้งหมดที่ผู้เล่นสั่งได้ในหนึ่งตา
 * ใช้ร่วมกันสองที่: โหมดเล่นเครื่องเดียว (ทำงานในเบราว์เซอร์)
 * และโหมดออนไลน์ (ส่งข้ามไปให้เซิร์ฟเวอร์ทำงานแทน)
 * เอนจินตรวจความถูกต้องเองอยู่แล้ว คำสั่งที่ทำไม่ได้จะกลายเป็น no-op
 */
export type GameAction =
  | { t: 'roll' }
  | { t: 'acceptRoll' }
  | { t: 'reroll' }
  | { t: 'confirm' }
  | { t: 'buy'; mode: 'cash' | 'loan' }
  | { t: 'skipBuy' }
  | { t: 'takeDeal'; cardId?: string }
  | { t: 'passDeal' }
  | { t: 'upgrade'; tileId: number }
  | { t: 'mortgage'; tileId: number }
  | { t: 'unmortgage'; tileId: number }
  | { t: 'sellProperty'; tileId: number }
  | { t: 'sellAsset'; uid: string }
  | { t: 'bail' }
  | { t: 'endTurn' }
  | { t: 'surrender' }

export function applyAction(g: GameState, a: GameAction): void {
  switch (a.t) {
    case 'roll':
      rollDice(g)
      break
    case 'acceptRoll':
      commitMove(g)
      break
    case 'reroll':
      reroll(g)
      break
    case 'confirm':
      confirmPrompt(g)
      break
    case 'buy':
      buyProperty(g, a.mode)
      break
    case 'skipBuy':
      skipBuy(g)
      break
    case 'takeDeal':
      acceptDeal(g, a.cardId)
      break
    case 'passDeal':
      declineDeal(g)
      break
    case 'upgrade':
      upgradeProperty(g, a.tileId)
      break
    case 'mortgage':
      mortgageProperty(g, a.tileId)
      break
    case 'unmortgage':
      unmortgageProperty(g, a.tileId)
      break
    case 'sellProperty':
      sellProperty(g, a.tileId)
      break
    case 'sellAsset':
      sellAsset(g, a.uid)
      break
    case 'bail':
      payBail(g)
      break
    case 'endTurn':
      endTurn(g)
      break
    case 'surrender':
      surrender(g)
      break
  }
}

/** คำสั่งที่แก้พอร์ตของตัวเองได้แม้ไม่ใช่ตาของตัวเอง (ไม่มี — กันโกงไว้ก่อน) */
export function isTurnAction(_a: GameAction): boolean {
  return true
}
